import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import Legend from './parts/Legend';
import { getColor } from './utils';
import { ValidationType } from './validation-type';

const ProgressionLegends = (props: { enrolled?: boolean }) => {
  const { enrolled = false } = props;
  const prefix = 'statusSemesterCourse';
  const { t } = useTranslation();

  return (
    <Row className="d-flex">
      {enrolled && (
        <Col xs={6} sm="auto">
          <Legend label={t(`${prefix}.enrolled`)} color={getColor('E')} />
        </Col>
      )}
      <Col xs={6} sm="auto">
        <Legend label={t(`${prefix}.approved`)} color={getColor('A')} />
      </Col>
      <Col xs={6} sm="auto">
        <Legend label={t(`${prefix}.pending`)} color={getColor('P')} />
      </Col>
      <Col xs={6} sm="auto">
        <Legend label={t(`${prefix}.failed`)} color={getColor('R')} />
      </Col>
      <Col xs={6} sm="auto">
        <Legend
          label={t(`${prefix}.internalValidation`)}
          color={getColor(ValidationType.Internal)}
        />
      </Col>
      <Col xs={6} sm="auto">
        <Legend
          label={t(`${prefix}.rap`)}
          color={getColor(ValidationType.RAP)}
        />
      </Col>
      <Col xs={6} sm="auto">
        <Legend
          label={t(`${prefix}.externalValidation`)}
          color={getColor(ValidationType.External)}
        />
      </Col>
    </Row>
  );
};

export default ProgressionLegends;
